export default __webpack_public_path__ + "static/media/Logo Main.9846ca3b.png";